/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  FeedCard,
  Column,
  Text,
  TEXT_VARIANTS,
  ExternalLink,
  Tagline,
} from "../..";

export const WebsiteCard: React.FC = () => (
  <FeedCard path="/link/id">
    <Column gap={10}>
      <img
        src="https://shorefire.com/images/made/images/uploads/files/OPN_RBNY_MYRIAD_P2_400_400_s_c1.png"
        alt=""
        css={css`
          object-fit: cover;
          width: 100%;
          height: 240px;
        `}
      />
      <Column crossAxisAlignment="start" gap={5}>
        <Text as="h3" variant={TEXT_VARIANTS.T30}>
          {
            "David Rudnick, Eric Hu, Callil Capuozzo: Design at the Edge FWB Fest 2022"
          }
        </Text>
        <Text as="p" variant={TEXT_VARIANTS.T20}>
          {
            "what if public libraries were open late every night and we could engage in public life there instead of having to choose between drinking at the bar and isolation"
          }
        </Text>
        <Tagline
          text="article · by $0"
          entities={[{ type: "person", name: "Gabriel Nessim Schloser" }]}
        />
        <ExternalLink>{"medium.com"}</ExternalLink>
      </Column>
    </Column>
  </FeedCard>
);
